import type { ReactNode } from 'react'
import cx from 'classnames'
import { match } from '@/utils/pattern-match-util'
import styles from './Pill.module.css'

interface PillProps {
  children?: ReactNode
  shape?: 'square' | 'pill'
  /**
   * `small` fits dense rows and headers, like a badge next to a title.
   */
  size?: 'normal' | 'small'
  trim?: boolean
  stout?: boolean
  color?: 'grey' | 'red' | 'green'
  title?: string
  testId?: string
}

/**
 * A small colored label.
 */
export function Pill({
  children,
  shape = 'pill',
  size = 'normal',
  trim,
  stout,
  color = 'grey',
  title,
  testId,
}: PillProps) {
  return (
    <div
      data-test={testId}
      className={cx(
        match(size, {
          normal: styles.default,
          small: styles.small,
        }),
        styles[color],
        styles[shape],
        trim && styles.trim,
        stout && styles.stout,
      )}
      title={title}
    >
      {children}
    </div>
  )
}
